import React from "react"
import { graphql } from "gatsby"
import { Container, Row, Col, Card } from "react-bootstrap"
import { PrismicRichText } from "@prismicio/react"
import { GatsbyImage } from "gatsby-plugin-image"
import { idMaker } from "../utils/idMaker"

export const GridCardsWithImages = ({ slice }) => {
  // console.log("GridCardsWithImages Slice: ", slice)

  return (
    <div
      className="grid_cards_with_images"
      id={idMaker(slice.primary.section_title?.text)}
    >
      <section className="bg-c-7 py-st-2">
        <Container>
          {/* Section Title */}
          <Row className="mb-3 mb-md-4">
            <Col className="text-center">
              <PrismicRichText
                field={slice.primary.section_title?.richText}
                components={{
                  heading2: ({ children }) => (
                    <h2 className="heading-st fs-st-5 mb-3">{children}</h2>
                  ),
                }}
              />
              <PrismicRichText
                field={slice.primary.section_subtitle?.richText}
                components={{
                  paragraph: ({ children }) => (
                    <p className="paragraph-st fs-st-10">{children}</p>
                  ),
                }}
              />
            </Col>
          </Row>

          {/* Grid Cards */}
          <Row xs={1} sm={2} lg={3} className="g-4 justify-content-center">
            {slice.items.map((item, index) => (
              <Col key={`grid-card-${index}`}>
                <Card className="grid-card-item h-100 shadow-sm bg-white border-0 p-3 p-md-4">
                  {/* Background image fill from bottom-right */}
                  {item.card_image?.gatsbyImageData && (
                    <div className="grid-card-bg-image" aria-hidden="true">
                      <GatsbyImage
                        image={item.card_image.gatsbyImageData}
                        alt=""
                        objectFit="cover"
                        objectPosition="bottom right"
                        style={{ width: "100%", height: "100%" }}
                      />
                    </div>
                  )}

                  {/* Text content sits above the image */}
                  <div className="grid-card-content">
                    {/* Small Title / Label */}
                    <PrismicRichText
                      field={item.card_label?.richText}
                      components={{
                        paragraph: ({ children }) => (
                          <p className="grid-card-label mb-2">
                            {children}
                          </p>
                        ),
                      }}
                    />

                    {/* Main Title */}
                    <PrismicRichText
                      field={item.card_title?.richText}
                      components={{
                        heading3: ({ children }) => (
                          <h3 className="grid-card-title mb-3">{children}</h3>
                        ),
                        heading4: ({ children }) => (
                          <h4 className="grid-card-title mb-3">{children}</h4>
                        ),
                      }}
                    />
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Scoped Styles */}
      <style>{`
        .grid_cards_with_images .grid-card-item {
          position: relative;
          overflow: hidden;
          transition: transform 0.3s ease, border-color 0.3s ease;
          border: 2px solid transparent;
          border-radius: 16px;
          min-height: 350px;
        }

        .grid_cards_with_images .grid-card-item:hover {
          transform: scale(1.02);
          border-color: var(--brand);
        }

        .grid_cards_with_images .grid-card-bg-image {
          position: absolute;
          inset: 0;
          z-index: 0;
        }

        .grid_cards_with_images .grid-card-bg-image > div,
        .grid_cards_with_images .grid-card-bg-image img {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important;
          object-position: bottom right !important;
        }

        .grid_cards_with_images .grid-card-content {
          position: relative;
          z-index: 1;
        }

        .grid_cards_with_images .grid-card-label {
          font-size: 0.85rem;
          color: #6c757d;
          font-weight: 500;
          margin-bottom: 0.5rem;
        }

        .grid_cards_with_images .grid-card-title {
          font-size: 1.1rem;
          font-weight: 600;
          color: #1a2b49;
          line-height: 1.4;
        }

        @media (min-width: 768px) {
          .grid_cards_with_images .grid-card-title {
            font-size: 1.25rem;
          }
        }
      `}</style>
    </div>
  )
}

export const query = graphql`
  fragment HomepageDataBodyGridCardsWithImages on PrismicHomepageDataBodyGridCardsWithImages {
    id
    slice_type
    primary {
      section_title {
        richText
        text
      }
      section_subtitle {
        richText
        text
      }
    }
    items {
      card_label {
        richText
        text
      }
      card_title {
        richText
        text
      }
      card_image {
        alt
        url
        gatsbyImageData
      }
    }
  }

  fragment PageDataBodyGridCardsWithImages on PrismicPageDataBodyGridcardswithimages {
    id
    slice_type
    primary {
      section_title {
        richText
        text
      }
      section_subtitle {
        richText
        text
      }
    }
    items {
      card_label {
        richText
        text
      }
      card_title {
        richText
        text
      }
      card_image {
        alt
        url
        gatsbyImageData
      }
    }
  }
`
